import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { keycloakService } from '@app/_services/keycloak.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private keycloakService: keycloakService) {  }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Add authorization header with jwt token if available
        let currentUser = this.keycloakService.currentUserValue;
        var token;

        if (currentUser && currentUser.token) {
            token = currentUser.token;
        }
        //else {
        //    token = this.keycloakService.getTokenCookie();
        //}

        if (token) {
            token = `Bearer ${token}`;

            request = request.clone({
                setHeaders: {
                    Authorization: token
                }
            });
        }

        return next.handle(request);
    }
}